var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-md-4 shadow" },
    [
      _c(
        "vs-list",
        _vm._l(_vm.participants, function(participant, index) {
          return _c("vs-list-item", {
            key: index,
            attrs: {
              icon: "description",
              title: participant.nombre,
              subtitle: participant.tipo === _vm.SIGNER ? "Firmante" : "Visador"
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }